module.exports = __webpack_public_path__ + "SMS.svg?f4618b9bc8c87efafbc18212405be0e0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/icons/SMS.svg
// module id = 40
// module chunks = 0